import type { Tag } from 'models';
import { Trans } from 'react-i18next';
import { Flex, TagList } from 'ui';
import { Text } from 'ui/typography';

type P = {
  tags: Tag[];
};

/**
 * @deprecated This component was only ported to TypeScript as-is as part of #86881, not redesigned. Do not use it as a
 * reference for new code.
 */
const ProgramTags = ({ tags }: P) => (
  <div className="description-card--tags__body">
    <Flex className="card-content" vertical>
      <Text className="card-content__title">
        <Trans>Tags</Trans>
      </Text>
      <TagList tags={tags} />
    </Flex>
  </div>
);

export default ProgramTags;
